<template>
    <div class="footer">
        <a @click="navigator('/about')">{{ store.langData.footer.about }}</a>
        <a @click="navigator('/service')">{{ store.langData.footer.service }}</a>
        <a @click="navigator('/policy')">{{ store.langData.footer.policy }}</a>
        <div class="logo-box">
            <div class="box">
                <img class="logo" src="../assets/logo2.png" alt="">
            </div>
            <p>{{ store.langData.footer.name }}</p>
            <p>{{ store.langData.footer.email }}</p>
            <p>{{ store.langData.footer.city }}</p>
        </div>
    </div>
</template>
    
<script setup>
    import { useStore } from '@/store/index'
    import { useRouter } from 'vue-router'

    const router = useRouter();
    const store = useStore()

    const navigator = (path) => {
        router.push({ path: path })
    }
</script>

<style scoped lang="scss">
    .footer {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 350px;
        margin: 0;
        padding: 0;
        gap: 30px;
        padding: 0px 20vw;
        box-sizing: border-box;
        background: #545454;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 24px;
        color: #FFFFFF;
        a {
            color: #FFFFFF;
            // text-decoration: none;
            user-select: none;
            cursor: pointer;
        }
        .logo-box {
            position: absolute;
            right: 10%;
            bottom: 10%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            align-self: flex-end;
            p {
                font-family: SourceHanSansCN, SourceHanSansCN;
                font-weight: 500;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                margin-bottom: 0px;
                max-width: 313px;
            }
            .box {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 14px;
                .logo {
                    width: 210px; 
                    height: 46px;
                    border-radius: 6px;
                }
                span {
                    font-family: SourceHanSansCN, SourceHanSansCN;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 24px;
                    text-align: left;
                    font-style: normal;
                }
            }
        }
    }
</style>